/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReportPackageFuture = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h16v9h-2V4H4v12h7v2H2z" />
        <path d="M5 10a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm4-2.83a3.001 3.001 0 1 0 3.941 2.236L9 11.763zm2 0v1.067l.914-.547A3.028 3.028 0 0 0 11 7.17zM4 22v-3h2v1h5v2zM20 6v5h2V4h-3v2zm-2 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm-.6-4.752V15h1.2v2.752l1.324 1.324-.848.848z" />
      </g>
    </g>
  </Icon>
);
export { SvgReportPackageFuture as ReportPackageFuture };
